import { render, staticRenderFns } from "./hospitalCard.vue?vue&type=template&id=27f34868&scoped=true"
import script from "./hospitalCard.vue?vue&type=script&lang=js"
export * from "./hospitalCard.vue?vue&type=script&lang=js"
import style0 from "./hospitalCard.vue?vue&type=style&index=0&id=27f34868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f34868",
  null
  
)

export default component.exports